// DEPRECATED!
import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Charge2DetailsEditable from "../Charge/Charge2DetailsEditable";
import Time from "../../../Time/Time";
import * as uuidV4 from "uuid/v4";
import Constants from "../../../Action/Constants";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Event } from "../../../Entity/Entities/Event/Event";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

interface StateInterface {
  newCharge: any;
  isSaving: boolean;
  isRentChargeCreateWarningPopupWasShown: boolean;
  isRentChargeCreateWarningPopupOpen: boolean;
}

class ChargeCreateDialog extends Component {
  public chargeDetails;

  public state: StateInterface = {
    newCharge: {},
    isSaving: false,
    isRentChargeCreateWarningPopupWasShown: false,
    isRentChargeCreateWarningPopupOpen: false
  };

  constructor(public props) {
    super(props);

    this.chargeDetails = React.createRef();
  }

  public onCancel = (): any => {
    this.setState({
      isSaving: false
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
      });
  
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel.call(this);
      }
    })
  }

  public onSave = (): any => {
    this.chargeDetails?.current?.updateParentState(() => {
      if (this.state.newCharge?.typeIdForCharge === TypeContainer.pickIdFromLabel("Rent") && !this.state.isRentChargeCreateWarningPopupWasShown) {
        return this.setState({
          isRentChargeCreateWarningPopupWasShown: true,
          isRentChargeCreateWarningPopupOpen: true
        });
      }

      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_CREATE_CLEAR
      });

      const charge: any = {
        amount: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2)),
        currency: this.state.newCharge?.currencyIdForCharge,
        type: this.state.newCharge?.typeIdForCharge,
        period: this.state.newCharge?.periodForCharge,
        firstDate: Time.formatOrNull(this.state.newCharge?.firstDateForCharge),
        dateOfPeriod: Time.formatOrNull(this.state.newCharge?.dateOfPeriodForCharge),
        dueDate: Time.formatOrNull(Time.firstDateSelectedMonth(this.state.newCharge?.dateOfPeriodForCharge)),
        description: this.state.newCharge?.descriptionForCharge,
        invoiceDate: Time.formatOrNull(this.state.newCharge?.invoiceDateForCharge),
        invoiceNumber: this.state.newCharge?.invoiceNumberForCharge,
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.vatForCharge)).replace(",", ".")).toFixed(2)),
        isInvoice: this.state.newCharge?.isInvoice,
        amazonFolderName: uuidV4(),
        paymentId: this.props.payment?.id,
        payment: this.props.payment
      };
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
        charge.propertyId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
        charge.unitId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
        charge.contractId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
        charge.ownerId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
        charge.eventId = this.state.newCharge?.selectedEntityForCharge?.id;
      }

      if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Person) {
        charge.contactId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
      }

      if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Company) {
        charge.companyId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
      }
  
      return this.saving(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_CREATE_START,
          payload: {
            charge: charge
          },
          onSuccess: (charge: ChargeInterface) => {
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });

            this.onCancel();

            if (typeof this.props.onSaveCallback === "function") {
              return this.props.onSaveCallback();
            }
  
            return this.redirect(`/app/charge/update/${charge.id}`);
          },
          onError: () => {
            return this.setState({
              hasModifiedData: true,
              isSaving: false,
              isRentChargeCreateWarningPopupWasShown: false
            });
          }
        });
      });
    });
  }

  public render() {
    return (
      <Dialog
        className={`dialog dialog-window has-button-padding ${this.props.innerDialogClasses ? this.props.innerDialogClasses : ""}`}
        open={this.props.isOpened}
        onClose={this.onCancel}
        disableBackdropClick={true}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
          }}>
            <div>
              <h4 style={{
                  margin: "15px 0 0 0",
                  padding: this.props.subtitle ? "20px 0 0 0" : "20px 0"
                }}
                >
                {this.props.title}
              </h4>
              {
                this.props.subtitle && (
                <div
                  style={{
                    fontSize: "13px",
                    paddingBottom: "9px",
                    fontWeight: "normal",
                    color: "rgb(137, 137, 137)",
                    margin: 0
                  }}
                  >{this.props.subtitle}</div>
                )
              }
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div style={{padding: "20px"}}>
            <Charge2DetailsEditable
              {...this.props} 
              ref={this.chargeDetails}
              dialogPresentation={true}
              chargeCreateProcess={true}
              updateState={(newChargeState, callback?) => {
                this.setState({
                  newCharge: {
                    ...newChargeState
                  }
                }, () => {
                  if (typeof callback === "function") {
                    callback();
                  }
                })
              }}
            />
          </div>
        </DialogContent>

        <div className="dialog-buttons-wrapper">
          <DialogActions>
            <Button
              color="primary"
              onClick={this.onCancel}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
            >
              {this.trans("dialog-button/create")}
            </Button>
          </DialogActions>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention")}
          content={
            <div>
              {this.trans("dialog/chargecreate-popup/rentcharge-info")}
            </div>
          }
          prioritizeClosing={true}
          openLeavePrompt={this.state.isRentChargeCreateWarningPopupOpen}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          onDiscard={() => this.setState({
            isRentChargeCreateWarningPopupWasShown: false,
            isRentChargeCreateWarningPopupOpen: false
          })}
          onSave={() => this.setState({isRentChargeCreateWarningPopupOpen: false}, this.onSave)}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    component: state.chargeCreateDialog,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  ChargeCreateDialog
);
